import BufferLogo from './BufferLogo.svg'
import burrow from './burrow.svg'
import dressup from './dressup.svg'
import food52 from './food52.svg'
import happysocks from './happysocks.svg'
import huckberry from './huckberry.svg'
import sch from './sch.webp'
import thesill from './thesill.svg'
import dd1 from './dd1.svg'
import dd2 from './dd2.svg'
import dd3 from './dd3.svg'
import dd4 from './dd4.svg'
import thumb from './thumb.webp'
import collaborate from './collaborate.webp'
import hero from './hero.webp'
import teammap from './teammap.webp'
import linkedinmarketing from './linkedinmarketing.webp'
import pinterestmarketing from './pinterestmarketing.webp'
import metabusiness from './metabusiness.webp'


const MySVG = {
    BufferLogo,
    burrow,
    dressup,
    food52,
    happysocks,
    huckberry,
    sch,
    thesill,
    dd1,
    dd2,
    dd3,
    dd4,
    thumb,
    collaborate,
    hero,
    teammap,
    linkedinmarketing,
    pinterestmarketing,
    metabusiness

}

export default MySVG
